module.exports = __webpack_public_path__ + "autopilot-2-1f64c8de85e9e9ca3530e1e8100b581c.webp";